import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "row mb-6" }
const _hoisted_23 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_24 = { class: "col-lg-8 fv-row" }
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { class: "row mb-6" }
const _hoisted_28 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_29 = { class: "col-lg-8" }
const _hoisted_30 = {
  class: "image-input image-input-outline",
  "data-kt-image-input": "true"
}
const _hoisted_31 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change image"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle-fill fs-6" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "avatar_create"
}, null, -1)
const _hoisted_34 = { class: "fv-plugins-message-container" }
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = { class: "form-text" }
const _hoisted_37 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_38 = {
  key: 0,
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_39 = { class: "indicator-label" }
const _hoisted_40 = { class: "indicator-progress" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('read', 'settings'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('updateBadge')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitUpdate,
            "validation-schema": _ctx.badgeSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('arabicName')), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('badgeNameAr'),
                      modelValue: _ctx.badge.titleAr,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.badge.titleAr) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_ErrorMessage, { name: "titleAr" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('englishName')), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('badgeNameEn'),
                      modelValue: _ctx.badge.titleEn,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.badge.titleEn) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_ErrorMessage, { name: "titleEn" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate('englishDescription')), 1),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "descriptionEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('descriptionEn'),
                      modelValue: _ctx.badge.descriptionEn,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.badge.descriptionEn) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_ErrorMessage, { name: "descriptionEn" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.translate('arabicDescription')), 1),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "descriptionAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('descriptionAr'),
                      modelValue: _ctx.badge.descriptionAr,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.badge.descriptionAr) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_ErrorMessage, { name: "descriptionAr" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.translate('badgeImage')), 1),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", {
                        class: "image-input-wrapper w-125px h-125px",
                        style: _normalizeStyle(`background-image: url(${_ctx.icon})`)
                      }, null, 4),
                      _createElementVNode("label", _hoisted_31, [
                        _hoisted_32,
                        _createVNode(_component_Field, {
                          type: "file",
                          name: "icon",
                          accept: ".png, .jpg, .jpeg",
                          onChange: _ctx.previewImage
                        }, null, 8, ["onChange"]),
                        _hoisted_33
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_ErrorMessage, { name: "icon" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.translate('allowedFileTypes')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                (_ctx.can('update', 'settings'))
                  ? (_openBlock(), _createElementBlock("button", _hoisted_38, [
                      _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.translate('saveChanges')), 1),
                      _createElementVNode("span", _hoisted_40, [
                        _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                        _hoisted_41
                      ])
                    ], 512))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}